let refreshPromise: Promise<boolean> | null = null;

function clearAllAuth() {
  localStorage.removeItem('casdoorToken');
  localStorage.removeItem('casdoorRefreshToken');
  localStorage.removeItem('casdoorUser');
  localStorage.removeItem('_authing_token');
  localStorage.removeItem('CurrentSchoolId');
  localStorage.removeItem('CurrentClassId');
}

function forceLogin() {
  clearAllAuth();
  window.location.assign(window.location.origin);
}

/**
 * Attempt to refresh the access token using the stored refresh token.
 * Returns true if successful (tokens updated in localStorage), false otherwise.
 * Concurrent callers share the same in-flight request.
 */
export async function tryRefreshToken(): Promise<boolean> {
  const refreshToken = localStorage.getItem('casdoorRefreshToken');
  if (!refreshToken) return false;

  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    try {
      const res = await fetch('/api/auth/casdoor/refresh', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken }),
      });

      if (!res.ok) return false;

      const data = await res.json();
      if (!data.accessToken) return false;

      localStorage.setItem('casdoorToken', data.accessToken);
      localStorage.setItem('_authing_token', data.accessToken);
      if (data.refreshToken) {
        localStorage.setItem('casdoorRefreshToken', data.refreshToken);
      }
      return true;
    } catch {
      return false;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}

export async function handleUnauthorizedWithRefresh(): Promise<boolean> {
  const refreshed = await tryRefreshToken();
  if (!refreshed) {
    forceLogin();
  }
  return refreshed;
}
